import React, { useEffect, useState } from "react";
import {
  Container, Table, Button, Input, Row, Col, Badge
} from "reactstrap";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "../Assets/css/style.css";
import AdminSidebar from "../Partials/adminsidebar";

const Candidates = () => {

  const [candidates, setCandidates] = useState([]);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const navigate = useNavigate();
  const handleReturn = () => {
    localStorage.removeItem("admin_token"); // optional logout
    navigate("/admin-login");
  };
  const fetchCandidates = async (pageNo = 1) => {

    const token = localStorage.getItem("admin_token");

    const res = await axios.get(
      // "http://localhost/qads_interview/admin/candidates.php",
      "https://interview.qads.co.in/qads_interview/admin/candidates.php",
      {
        headers: { Authorization: `Bearer ${token}` },
        params: { search, page: pageNo, limit: 10 }
      }
    );

    setCandidates(res.data.data.candidates);

    setTotalPages(res.data.data.pagination.total_pages);
    setPage(pageNo);
  };

  useEffect(() => {
    fetchCandidates(1);
  }, []);

  return (
    <div style={{ display: "flex" }}>

  {/* Sidebar */}
  <AdminSidebar />

  {/* Main Content Area */}
  <div style={{
    marginLeft: "250px",
    width: "100%",
    padding: "20px"
  }}>

    <Container className="mt-4">

      {/* Header Row - Search + Return */}
      <Row className="mb-3">

        {/* Search Input */}
        <Col xs="12" md="4" className="mb-2 mb-md-0">
          <Input
            placeholder="Search by name/email"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </Col>

        {/* Search Button */}
        <Col xs="12" md="2" className="mb-2 mb-md-0">
          <Button
            onClick={fetchCandidates}
            className="search-btn "
          >
            Search
          </Button>
        </Col>

        

      </Row>


      {/* Table */}
      <Table bordered hover responsive>
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Domain</th>
            <th>Status</th>
            <th>Marks</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {candidates.map((c) => (
            <tr key={c.user_id}>
              <td>{c.name}</td>
              <td>{c.email}</td>
              <td>{c.domain}</td>

              <td>
                {c.interview_completed ? (
                  <span>Completed</span>
                ) : (
                  <span className="text-danger fw-bold">
                    InComplete
                  </span>
                )}
              </td>
              <td>
                {c.percentage ?? "-"}%
              </td>

              <td>
                <Button
                  size="sm"
                  color="info"
                  onClick={() => navigate(`/admin-view/${c.user_id}`)}
                >
                  View
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <div className="d-flex justify-content-end mt-3 gap-2 align-items-center">

        <Button
          className="pagination-btn"
          disabled={page === 1}
          onClick={() => fetchCandidates(page - 1)}
        >
          Prev
        </Button>

        <span>
          Page {page} / {totalPages}
        </span>

        <Button
          className="pagination-btn"
          disabled={page === totalPages}
          onClick={() => fetchCandidates(page + 1)}
        >
          Next
        </Button>

      </div>
    </Container>

  </div>

</div>
    
  );
};

export default Candidates;


